var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatformIconB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 63,
    viewBox: "0 0 56 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1395_3260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1684 0.941406C50.9922 0.941406 50.0369 1.8947 50.0369 3.07083C50.0369 3.3659 50.0988 3.65684 50.2184 3.92508C48.2706 5.54691 46.5683 6.95621 44.7731 8.42122C44.3192 8.75961 44.8371 9.29403 45.1219 9.08976C46.8737 7.66808 48.9577 5.9534 50.6456 4.56267C51.0459 4.97122 51.5927 5.20026 52.1642 5.20026C53.3404 5.20026 54.2937 4.24697 54.2937 3.07083C54.2937 1.8947 53.3404 0.941406 52.1642 0.941406H52.1684Z",
    fill: "#4C77EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2327 6.67006C35.8572 6.65974 35.6921 7.24574 36.0491 7.38399C37.8917 8.10618 39.7178 8.83043 41.3809 9.48659C41.3768 9.53405 41.3747 9.58151 41.3747 9.6269C41.3747 10.803 42.328 11.7563 43.5041 11.7563C44.6803 11.7563 45.6336 10.803 45.6336 9.6269C45.6336 8.45077 44.6803 7.49748 43.5041 7.49748C42.6643 7.49748 41.905 7.99063 41.5625 8.75821C39.8932 8.11031 38.0134 7.35923 36.406 6.71339C36.3441 6.6845 36.2864 6.67212 36.2327 6.67006Z",
    fill: "#4C77EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3357 11.4238H36.3813C37.0065 11.4238 37.512 11.9273 37.512 12.5546V22.4073C37.512 23.0325 37.0086 23.538 36.3813 23.538H33.3357C32.7105 23.538 32.205 23.0346 32.205 22.4073V12.5546C32.205 11.9294 32.7085 11.4238 33.3357 11.4238Z",
    fill: "#B6C7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3357 11.4238H36.3813C37.0065 11.4238 37.512 11.9273 37.512 12.5546V22.4073C37.512 23.0325 37.0086 23.538 36.3813 23.538H33.3357C32.7105 23.538 32.205 23.0346 32.205 22.4073V12.5546C32.205 11.9294 32.7085 11.4238 33.3357 11.4238Z",
    fill: "url(#paint0_linear_1395_3260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9814 14.6963H45.0269C45.6521 14.6963 46.1577 15.1998 46.1577 15.827V22.4072C46.1577 23.0324 45.6542 23.5379 45.0269 23.5379H41.9814C41.3561 23.5379 40.8506 23.0345 40.8506 22.4072V15.827C40.8506 15.2018 41.3541 14.6963 41.9814 14.6963Z",
    fill: "#B6C7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9814 14.6963H45.0269C45.6521 14.6963 46.1577 15.1998 46.1577 15.827V22.4072C46.1577 23.0324 45.6542 23.5379 45.0269 23.5379H41.9814C41.3561 23.5379 40.8506 23.0345 40.8506 22.4072V15.827C40.8506 15.2018 41.3541 14.6963 41.9814 14.6963Z",
    fill: "url(#paint1_linear_1395_3260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6456 7.28038H53.6911C54.3163 7.28038 54.8219 7.78385 54.8219 8.41113V22.4071C54.8219 23.0324 54.3184 23.5379 53.6911 23.5379H50.6456C50.0203 23.5379 49.5148 23.0344 49.5148 22.4071V8.40906C49.5148 7.78385 50.0183 7.27832 50.6456 7.27832V7.28038Z",
    fill: "#B6C7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6456 7.28038H53.6911C54.3163 7.28038 54.8219 7.78385 54.8219 8.41113V22.4071C54.8219 23.0324 54.3184 23.5379 53.6911 23.5379H50.6456C50.0203 23.5379 49.5148 23.0344 49.5148 22.4071V8.40906C49.5148 7.78385 50.0183 7.27832 50.6456 7.27832V7.28038Z",
    fill: "url(#paint2_linear_1395_3260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.99 6.47025C36.99 7.64638 36.0367 8.59967 34.8606 8.59967C33.6844 8.59967 32.7311 7.64638 32.7311 6.47025C32.7311 5.29411 33.6844 4.34082 34.8606 4.34082C36.0367 4.34082 36.99 5.29411 36.99 6.47025Z",
    fill: "#4C77EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5437 22.3469V22.4418C49.5437 23.0691 50.0492 23.5725 50.6745 23.5725H53.2248C53.4848 23.2465 53.4332 22.7719 53.1093 22.512C52.971 22.4005 52.7977 22.3428 52.6202 22.3469H49.5416H49.5437Z",
    fill: "#4C77EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8671 22.3467V22.4416C40.8671 22.7552 40.993 23.0379 41.1973 23.2422C41.4016 23.4465 41.6842 23.5723 41.9979 23.5723H45.0476C45.3612 23.5723 45.6439 23.4465 45.8482 23.2422C46.0525 23.0379 46.1783 22.7552 46.1783 22.4416V22.3467H40.8651H40.8671Z",
    fill: "#4C77EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5903 23.5723H36.3895C36.7032 23.5723 36.9859 23.4465 37.1901 23.2422C37.3944 23.0379 37.5203 22.7552 37.5203 22.4416V22.3467H35.1783C34.7615 22.3467 34.4252 22.6851 34.4252 23.1019C34.4252 23.2731 34.485 23.4382 34.5903 23.5723Z",
    fill: "#FFAB61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 62.696C37.5126 62.696 48.2577 51.9509 48.2577 38.6962C48.2577 25.4414 37.5126 14.6963 24.2578 14.6963C11.003 14.6963 0.257935 25.4414 0.257935 38.6962C0.257935 51.9509 11.003 62.696 24.2578 62.696Z",
    fill: "url(#paint3_linear_1395_3260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 62.696C37.5126 62.696 48.2577 51.9509 48.2577 38.6962C48.2577 25.4414 37.5126 14.6963 24.2578 14.6963C11.003 14.6963 0.257935 25.4414 0.257935 38.6962C0.257935 51.9509 11.003 62.696 24.2578 62.696Z",
    fill: "url(#paint4_linear_1395_3260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2578 56.3575C34.0116 56.3575 41.9185 48.4506 41.9185 38.6968C41.9185 28.9431 34.0116 21.0361 24.2578 21.0361C14.5041 21.0361 6.59715 28.9431 6.59715 38.6968C6.59715 48.4506 14.5041 56.3575 24.2578 56.3575Z",
    fill: "url(#paint5_linear_1395_3260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.223 42.9955H16.4195V38.6766H22.9042V28.6777H27.223V42.9955Z",
    fill: "url(#paint6_linear_1395_3260)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1395_3260",
    x1: 32.9042,
    y1: 12.3975,
    x2: 42.6158,
    y2: 15.8522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9AF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1395_3260",
    x1: 41.5498,
    y1: 15.407,
    x2: 50.3903,
    y2: 19.7157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9AF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1395_3260",
    x1: 50.214,
    y1: 8.58523,
    x2: 60.4365,
    y2: 11.2945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9AF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1395_3260",
    x1: 40.936,
    y1: 14.6963,
    x2: 16.8524,
    y2: 63.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D84F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1395_3260",
    x1: 40.936,
    y1: 14.6963,
    x2: 16.8524,
    y2: 63.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D84F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1395_3260",
    x1: 21.4006,
    y1: 21.5163,
    x2: 21.4006,
    y2: 59.1306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#819CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1395_3260",
    x1: 17.8427,
    y1: 29.8286,
    x2: 34.0356,
    y2: 39.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9AF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1395_3260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 62,
    fill: "white",
    transform: "translate(0.13855 0.933594)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformIconB);
export default __webpack_public_path__ + "static/media/platform_iconB.84a67378e8f8ca049f828118082b3995.svg";
export { ForwardRef as ReactComponent };